const notFound = {
    notFoundMessage: 'הדף הזה לא קיים',
    description: 'ייתכן שהקישור שבור או שהדף עבר למקום אחר. חזרו לדף הבית ונסו משם.',
    backHome: 'חזרה לדף הבית',
};

export default notFound;
